import React from 'react';

export function PostCardImage() {
  return (
    <svg width="240" height="240" viewBox="0 0 240 240" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="120" cy="120" r="110" fill="#FFEADE" fillOpacity="0.5" />
      <path
        d="M26.8753 102.16L104.757 35.2086C109.159 31.4215 115.532 30.8725 120.516 33.8509L208.702 86.4953L217.709 191.042L36.5223 206.652L26.8753 102.16Z"
        fill="#FF7020"
      />
      <path d="M50.7601 185.224L52.1979 43.0358L192.528 44.3877L191.121 184.132" fill="#FEFCFB" />
      <path
        d="M50.7601 185.224L52.1979 43.0358L192.528 44.3877L191.121 184.132"
        stroke="#060505"
        strokeMiterlimit="10"
      />
      <path
        d="M145.318 102.078C145.311 102.031 145.276 101.992 145.227 101.979C145.177 101.962 145.124 101.976 145.088 102.009C145.088 102.009 145.057 102.039 144.992 102.095C144.927 102.153 144.829 102.238 144.698 102.346C144.438 102.563 144.048 102.871 143.53 103.242C143.162 103.505 142.731 103.799 142.236 104.114C142.235 104.105 142.234 104.098 142.233 104.09C136.213 107.985 129.189 109.647 122.361 109.678C122.303 109.679 122.244 109.678 122.186 109.678C121.995 109.678 121.803 109.678 121.612 109.675C121.424 109.674 121.239 109.676 121.049 109.673L121.049 109.673L121.049 109.673C114.391 109.548 109.093 107.968 105.206 106.198C102.412 104.959 99.9515 103.438 97.9805 101.714C97.8733 101.622 97.7737 101.536 97.6927 101.463C97.5667 101.35 97.4725 101.261 97.4095 101.201C97.3475 101.142 97.3177 101.112 97.3167 101.112C97.2822 101.077 97.2281 101.062 97.1791 101.076C97.1298 101.088 97.0929 101.125 97.0848 101.172C97.0556 101.344 97.0312 101.562 97.0265 101.816L97.0254 101.874L97.025 101.892C97.0272 102.548 97.2629 103.058 97.9119 103.622C98.0685 103.772 106.778 112.083 120.999 112.353L120.999 112.351L120.999 112.353C135.22 112.618 144.237 104.639 144.399 104.495C145.069 103.956 145.324 103.455 145.35 102.8L145.35 102.782L145.351 102.724C145.356 102.47 145.342 102.251 145.318 102.078Z"
        fill="#060505"
      />
      <path
        d="M218.495 200.175L36.669 215.84L26.9409 102.925L122.899 153.653L208.767 87.2598L218.495 200.175Z"
        fill="#FF7020"
        stroke="#FEFCFB"
        strokeMiterlimit="10"
      />
      <path
        d="M36.5979 215.01L113.247 144.516C118.076 140.068 125.329 139.444 130.848 143L218.424 199.345"
        fill="#FF7020"
      />
      <path
        d="M36.5979 215.01L113.247 144.516C118.076 140.068 125.329 139.444 130.848 143L218.424 199.345"
        stroke="#FEFCFB"
        strokeMiterlimit="10"
      />
    </svg>
  );
}
